if (!customElements.get('takoo-creator-videos')) {
  customElements.define('takoo-creator-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      if (this.dataset.draftTest === 'true') {
        if (window.Shopify?.theme?.role !== 'unpublished') return;
        this.hidden = false;
      }
      this.initialized = true;
      this.player = this.querySelector('video');
      this.start = this.querySelector('.takoo-creator__start');
      this.choices = [...this.querySelectorAll('[data-src]')];
      if (!this.player || !this.start || !this.choices.length) return;
      this.choices.forEach(choice => choice.addEventListener('click', () => this.select(choice)));
      this.start.addEventListener('click', () => {
        this.player.src = this.selected.dataset.src;
        this.player.hidden = false;
        this.start.hidden = true;
        this.player.play().catch(() => { /* Native controls remain available. */ });
      });
      this.player.addEventListener('play', () => {
        document.querySelectorAll('takoo-creator-videos video').forEach(other => {
          if (other !== this.player) other.pause();
        });
      });
      this.onVisibility = () => { if (document.hidden) this.player.pause(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.select(this.choices[0]);

    }
    select(choice) {
      if (this.selected === choice) return;
      this.player.pause();
      this.player.removeAttribute('src');
      this.player.load();
      this.player.hidden = true;
      this.start.hidden = false;
      this.selected = choice;
      this.player.dataset.silent = String(choice.dataset.silent === 'true');
      this.player.muted = true;
      this.start.querySelector('img').src = choice.dataset.poster;
      this.player.poster = choice.dataset.poster;
      this.choices.forEach(item => item.setAttribute('aria-pressed', String(item === choice)));
    }
    disconnectedCallback() {
      this.player?.pause();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
